//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
// import {showMovie} from "../include/module";
// showMovie();

//tabSwitchingCampaign
import {tabSwitchingCampaign} from "../include/module";
tabSwitchingCampaign();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {
  btnPosition();
});


// ------------------------------------------------------------------------
// btnPosition
// ----- BOTH
// ------------------------------------------------------------------------
const btnPosition = () => {
  var btnCampaign = $('#sw-Btn-campaign')
  var btnPosition = $('#btn-position')

  $(window).on("load resize scroll", function(){

    var windowW         = $(window).width();
    var windowH         = $(window).height();
    var scrollPosition  = $(window).scrollTop();
    var entryPosition   = $('#entry').offset().top;
    var btnPositionNum   = btnPosition.offset().top;
    var stopPosition    = btnPositionNum - windowH + 40;
    var releasePosition = entryPosition - windowH;
    //PCの時
    if(windowW >= 1025){
      if(scrollPosition >= releasePosition){
        //応募方法まできたらボタン消す
        btnCampaign.addClass('hidden');
      }
      else if(scrollPosition >= stopPosition){
        //ページ上部のボタン位置まできたらボタン出す
        btnCampaign.removeClass('hidden');
      }
      else {
        //ページ上部のボタン位置より上の時はボタン消す
        btnCampaign.addClass('hidden');
      }
    }
    else {
      if(scrollPosition >= releasePosition){
        //応募方法まできたらボタン消す
        btnCampaign.addClass('hidden');
      }
      else if(scrollPosition >= 70){
        //ページ上部のボタン位置まできたらボタン出す
        btnCampaign.removeClass('hidden');
      }
      else {
        //ページ上部のボタン位置より上の時はボタン消す
        btnCampaign.addClass('hidden');
      }
    }
  });

}



// WEBPACK FOOTER //
// ./src/assets/js/campaign/script.js